<div class="invite-modal">
  <h3>Notifications Received</h3>
  <ul>
    @for (m of data.messages; track m) {
      <li> {{ m }}</li>
    }
  </ul>


  <footer>
    <button mat-stroked-button (click)="close()">
      Close
    </button>
  </footer>
</div>
